import './App.css';
import { RecommandationsPage } from './pages/recommandations';
import { RecommandationsAnneePage } from './pages/annee';
import { FindfilmsPage } from './pages/findfilms';
import { AccueilPage } from './pages/accueilpage';
import { Navbar } from './components/Navbar';
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/trouver_film" element={<FindfilmsPage />} />
        <Route path="/recommandation_par_genre" element={<RecommandationsPage />} />
        <Route path="/recommandation_par_annee" element={<RecommandationsAnneePage />} />
        <Route index path="/" element={<AccueilPage />} />
        
      </Routes>
    </>
  );
}

export default App;
